import React from 'react';
import constants from 'Constants';


export default class ZendeskWrapper extends React.Component {
  constructor (props) {
    super(props);
  }

  componentDidMount() {
    window.zESettings = {
      webWidget: {
        launcher: {
          label: {
            '*': 'Ask Support',
          }
        }
      }
    };

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'ze-snippet';
    script.async = true;
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${constants.ZENDESK_WEB_WIDGET_KEY}`;
    script.onload = () => this.onScriptLoaded();
    this.ref.appendChild(script);
  }

  onScriptLoaded = () => {
    zE('webWidget', 'hide');
  };

  render() {
    return (
      <div
        id="zendesk_wrapper"
        ref={(ref) => this.ref = ref}
      >
      </div>
    );
  }
}



